import { DayWofWeek } from 'src/Libs/smart-charge/api/types'

export const INPUT_WEEKDAY_SEQUENCE = [
  DayWofWeek.monday,
  DayWofWeek.tuesday,
  DayWofWeek.wednesday,
  DayWofWeek.thursday,
  DayWofWeek.friday,
  DayWofWeek.saturday,
  DayWofWeek.sunday,
]
